/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TotalOverview.vue?vue&type=template&id=193ab054&scoped=true"
import script from "./TotalOverview.vue?vue&type=script&lang=js"
export * from "./TotalOverview.vue?vue&type=script&lang=js"
import style0 from "./TotalOverview.vue?vue&type=style&index=0&id=193ab054&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ab054",
  null
  
)

export default component.exports